(function($) {
	$('body').removeClass('no-js').addClass('js');
})(jQuery);